import React, { useState } from 'react';
import { useLocation, Router } from 'react-router-dom';
import SideBarContainer from 'Containers/SideBarContainer';
import SelectTable from '../../Components/SelectTable';
import Search from '../../Components/Search';
import Title from '../../Components/Title';
import style from './style';
import useJobTitle from './Hooks/useJobTitle';
import useComponent from './Hooks/useComponent';
import useSearch from './Hooks/useSearch';
import useTranslation from '../../Hooks/useTranslation';
import useRoute from './Hooks/useRoute';

const { containerEmployee, searchContainer } = style;

export default function Departments() {
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(true);
  if (location?.state?.isComingFrom !== '/definicion') {
    return <Router to="/definicion" />;
  }
  const { t } = useTranslation();
  const { jobTitle, setJobTitle } = useJobTitle(setIsLoading);
  const { thereIsComponent } = useComponent({ jobTitle, setJobTitle });
  const { setSearch, jobTitleFilters } = useSearch({
    jobTitle,
  });
  const { handlePage } = useRoute();

  return (
    <SideBarContainer>
      <div style={containerEmployee}>
        <Title title="Puestos" subtitle="" />
        <div style={searchContainer}>
          <div style={{ width: '40%' }}>
            <Search placeholder={t('JobTitle.Title')} setData={setSearch} />
          </div>
        </div>

        <SelectTable
          headers={[
            t('JobTitle.Name'),
            t('JobTitle.Department'),
            t('JobTitle.TotalEmployees'),
            t('JobTitle.TotalCourses'),
            t('JobTitle.Status'),
          ]}
          information={jobTitleFilters}
          thereIsComponent={thereIsComponent}
          limit={5}
          checkbox={false}
          event={handlePage}
          isLoading={isLoading}
        />
      </div>
    </SideBarContainer>
  );
}
